module.exports = __webpack_public_path__ + "img/japan.94115cd7.svg";